var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ob1-price",
      class: {
        "ob1-price-mini": _vm.isMini,
        "ob1-price-compact": _vm.isCompact,
        "ob1-price-inverse": _vm.isInverse,
      },
      attrs: { "data-ob1-component": "Price" },
    },
    [
      _c("p", {
        staticClass: "visually-hidden",
        domProps: { innerHTML: _vm._s(_vm.priceAccessibility) },
      }),
      _vm._v(" "),
      _c(
        "p",
        { attrs: { "aria-hidden": "true" } },
        [
          _vm.priceLabel
            ? [
                _c("span", {
                  staticClass: "ob1-price-amount-label",
                  domProps: { innerHTML: _vm._s(_vm.priceLabel) },
                }),
              ]
            : [
                _vm.showFrom
                  ? _c("span", { staticClass: "ob1-price-from" }, [
                      _vm._v("à partir de"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  class: _vm.priceClassObject,
                  domProps: { innerHTML: _vm._s(_vm.formattedPrice) },
                }),
                _vm._v(" "),
                _vm.showByMonth
                  ? _c("span", { staticClass: "ob1-price-by-month" }, [
                      _vm._v("/mois"),
                    ])
                  : _vm._e(),
              ],
          _vm._v(" "),
          _vm.showInitialPriceStrikethrough
            ? _c("span", {
                class: _vm.initialPriceStrikethroughClasses,
                domProps: {
                  innerHTML: _vm._s(_vm.formattedInitialPriceStrikethrough),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showPromoDuration && !_vm.cashbackType
            ? _c("span", { staticClass: "ob1-price-promo-duration" }, [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.getDuration) },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "ob1-price-promo-duration-by-month",
                  domProps: {
                    innerHTML: _vm._s(_vm.formattedInitialPrice + "/mois"),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showUntilEndOfPromo
            ? _c("span", { staticClass: "ob1-price-promo-duration" }, [
                _c("span", [
                  _vm._v("jusqu'à la fin de vos promotions en cours puis "),
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "ob1-price-promo-duration-by-month",
                  domProps: {
                    innerHTML: _vm._s(_vm.formattedInitialPrice + "/mois"),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showEndOfPromotionPrice && !_vm.cashbackType
            ? _c("span", { staticClass: "ob1-price-promo-duration" }, [
                _c("span", [_vm._v("puis ")]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "ob1-price-promo-duration-by-month",
                  domProps: {
                    innerHTML: _vm._s(_vm.formattedInitialPrice + "/mois"),
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(" à la fin de vos promotions")]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.cashbackType
            ? _c("span", { staticClass: "ob1-price-promo-duration" }, [
                _vm.duration >= 1 && !_vm.showEndOfPromotionPrice
                  ? _c("span", [
                      _c("span", [
                        _vm._v("Pendant " + _vm._s(_vm.duration) + " mois,"),
                      ]),
                      _vm._v(" "),
                      _vm.cashbackMentionWithDuration
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.cashbackMentionWithDuration) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _c("span", [
                      _vm.cashbackMention
                        ? _c("span", [
                            _vm._v(" " + _vm._s(_vm.cashbackMention) + " "),
                          ])
                        : _vm._e(),
                    ]),
                _vm._v(" "),
                _c("span", [_vm._v(" (après validation du remboursement)")]),
                _vm._v(" "),
                _vm.duration >= 1
                  ? _c("span", [
                      _c("span", [_vm._v("puis ")]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ob1-price-promo-duration-by-month",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.formattedInitialPrice + "/mois"
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _vm.showEndOfPromotionPrice
                        ? _c("span", [_vm._v(" à la fin de vos promotions")])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showChildrenPromotionPrice
            ? _c("span", { staticClass: "ob1-price-promo-duration" }, [
                _c("span", [_vm._v("pour vos enfants de -18 ans au lieu de ")]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "ob1-price-promo-duration-by-month",
                  domProps: {
                    innerHTML: _vm._s(_vm.formattedInitialPrice + "/mois"),
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.priceDetails && _vm.priceDetails.length > 0
            ? _c("span", {
                staticClass: "ob1-price-promo-duration pt-0",
                domProps: { innerHTML: _vm._s(_vm.priceDetails) },
              })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", [_c("sup", [_vm._v("(1)")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }